(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bat-man"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('producto-nerea')) return;

    class ProductoNerea extends HTMLElement {
      connectedCallback() {
        const datos = this.querySelector('[data-variantes-json]');
        this.variantes = datos ? JSON.parse(datos.textContent) : [];
        this.pista = this.querySelector('[data-pista]');
        this.diapositivas = Array.from(this.querySelectorAll('[data-diapositiva]'));
        this.miniaturas = Array.from(this.querySelectorAll('[data-miniatura]'));
        this.puntos = Array.from(this.querySelectorAll('[data-punto]'));
        this.formulario = this.querySelector('.producto-nr__formulario');
        this.indiceActivo = 0;

        this.iniciarGaleria();
        this.iniciarVariantes();
        this.iniciarFormulario();
        this.iniciarGuia();
        this.iniciarCantidad();
        this.iniciarPaquetes();

        const inicial = parseInt(this.dataset.mediaInicial, 10) || 0;
        requestAnimationFrame(() => this.irA(inicial, false));
      }

      iniciarGaleria() {
        if (!this.pista) return;

        this.miniaturas.forEach((miniatura) => {
          miniatura.addEventListener('click', () => this.irA(parseInt(miniatura.dataset.indice, 10), true));
        });

        this.puntos.forEach((punto) => {
          punto.addEventListener('click', () => this.irA(parseInt(punto.dataset.indice, 10), true));
        });

        let espera;
        this.pista.addEventListener('scroll', () => {
          clearTimeout(espera);
          espera = setTimeout(() => {
            const ancho = this.pista.clientWidth || 1;
            const indice = Math.round(this.pista.scrollLeft / ancho);
            this.marcarActivo(indice);
          }, 60);
        }, { passive: true });
      }

      irA(indice, suave) {
        const destino = this.diapositivas[indice];
        if (!destino || !this.pista) return;
        this.pista.scrollTo({ left: destino.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
        this.marcarActivo(indice);
      }

      marcarActivo(indice) {
        this.indiceActivo = indice;
        this.miniaturas.forEach((miniatura, posicion) => {
          miniatura.classList.toggle('producto-nr__miniatura--activa', posicion === indice);
        });
        const activa = this.miniaturas[indice];
        const columna = activa ? activa.parentElement : null;
        if (activa && columna && columna.scrollHeight > columna.clientHeight) {
          columna.scrollTo({ top: activa.offsetTop - (columna.clientHeight - activa.clientHeight) / 2, behavior: 'smooth' });
        }
        this.puntos.forEach((punto, posicion) => {
          punto.classList.toggle('producto-nr__punto--activo', posicion === indice);
        });
      }

      iniciarVariantes() {
        this.radios = Array.from(this.querySelectorAll('.producto-nr__radio'));
        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.alCambiarOpcion(radio));
        });
        this.marcarDisponibilidad();
      }

      opcionesSeleccionadas() {
        const seleccion = [];
        this.querySelectorAll('[data-opcion]').forEach((grupo) => {
          const posicion = parseInt(grupo.dataset.posicion, 10) - 1;
          const marcado = grupo.querySelector('.producto-nr__radio:checked');
          seleccion[posicion] = marcado ? marcado.value : null;
        });
        return seleccion;
      }

      alCambiarOpcion(radio) {
        const seleccion = this.opcionesSeleccionadas();
        let variante = this.variantes.find((v) => v.opciones.every((valor, i) => seleccion[i] === undefined || seleccion[i] === null || seleccion[i] === valor));

        if (!variante || !variante.disponible) {
          const posicion = parseInt(radio.dataset.posicion, 10) - 1;
          const alternativa = this.variantes.find((v) => v.disponible && v.opciones[posicion] === radio.value);
          if (alternativa && !variante) {
            variante = alternativa;
            this.aplicarSeleccion(alternativa);
          }
        }

        if (variante) this.actualizar(variante);
        this.marcarDisponibilidad();
      }

      aplicarSeleccion(variante) {
        variante.opciones.forEach((valor, i) => {
          const grupo = this.querySelector('[data-opcion][data-posicion="' + (i + 1) + '"]');
          if (!grupo) return;
          grupo.querySelectorAll('.producto-nr__radio').forEach((radio) => {
            radio.checked = radio.value === valor;
          });
        });
      }

      marcarDisponibilidad() {
        const seleccion = this.opcionesSeleccionadas();
        this.querySelectorAll('[data-opcion]').forEach((grupo) => {
          const posicion = parseInt(grupo.dataset.posicion, 10) - 1;
          grupo.querySelectorAll('.producto-nr__valor').forEach((etiqueta) => {
            const radio = etiqueta.querySelector('.producto-nr__radio');
            const disponible = this.variantes.some((v) => {
              if (!v.disponible || v.opciones[posicion] !== radio.value) return false;
              return v.opciones.every((valor, i) => i === posicion || seleccion[i] === null || seleccion[i] === undefined || seleccion[i] === valor);
            });
            etiqueta.classList.toggle('producto-nr__valor--agotado', !disponible);
          });
          const marcado = grupo.querySelector('.producto-nr__radio:checked');
          const texto = grupo.querySelector('[data-valor-seleccionado]');
          if (texto && marcado) texto.textContent = marcado.value;
        });
      }

      actualizar(variante) {
        this.varianteActual = variante;

        const campoId = this.querySelector('[data-id-variante]');
        if (campoId) campoId.value = variante.id;

        const antes = this.querySelector('[data-precio-antes]');
        const actual = this.querySelector('[data-precio-actual]');
        const etiqueta = this.querySelector('[data-etiqueta]');
        const enOferta = Boolean(variante.antes);

        if (actual) {
          actual.innerHTML = variante.precio;
          actual.classList.toggle('producto-nr__precio-actual--oferta', enOferta);
        }
        if (antes) {
          antes.innerHTML = enOferta ? variante.antes : '';
          antes.classList.toggle('producto-nr__oculto', !enOferta);
        }
        if (etiqueta) {
          if (enOferta) {
            etiqueta.innerHTML = (etiqueta.dataset.plantilla || '')
              .replace('[porcentaje]', variante.porcentaje)
              .replace('[ahorro]', variante.ahorro);
          }
          etiqueta.classList.toggle('producto-nr__oculto', !enOferta);
        }

        const boton = this.querySelector('[data-agregar]');
        if (boton) {
          boton.disabled = !variante.disponible;
          const textoBoton = boton.querySelector('[data-agregar-texto]');
          if (textoBoton) textoBoton.textContent = variante.disponible ? boton.dataset.textoAgregar : boton.dataset.textoAgotado;
        }

        const stock = this.querySelector('[data-stock]');
        if (stock) {
          let visible = false;
          if (variante.disponible) {
            if (stock.dataset.modo === 'siempre') {
              visible = true;
            } else if (variante.inventario !== null && variante.inventario > 0 && variante.inventario <= parseInt(stock.dataset.umbral, 10)) {
              visible = true;
            }
          }
          stock.classList.toggle('producto-nr__oculto', !visible);
        }

        if (variante.media) {
          const indice = this.diapositivas.findIndex((d) => d.dataset.mediaId === String(variante.media));
          if (indice > -1) this.irA(indice, true);
        }

        if (this.dataset.actualizarUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', url.toString());
        }

        this.recalcularPaquetes(variante);
        this.ocultarError();
      }

      iniciarFormulario() {
        if (!this.formulario) return;
        this.formulario.addEventListener('submit', (evento) => {
          evento.preventDefault();
          this.agregarAlCarrito();
        });
      }

      agregarAlCarrito() {
        const boton = this.querySelector('[data-agregar]');
        if (!boton || boton.disabled || boton.classList.contains('producto-nr__agregar--cargando')) return;

        this.ocultarError();
        boton.classList.add('producto-nr__agregar--cargando');
        boton.setAttribute('aria-busy', 'true');

        const datos = new FormData(this.formulario);
        const carritoNerea = document.querySelector('carrito-nerea');
        const cajon = document.querySelector('cart-drawer');
        const usaCajon = !carritoNerea && cajon && typeof cajon.renderContents === 'function' && typeof cajon.getSectionsToRender === 'function';

        if (usaCajon) {
          datos.append('sections', cajon.getSectionsToRender().map((s) => s.id));
          datos.append('sections_url', window.location.pathname);
        }

        fetch(this.dataset.urlAgregar + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: datos
        })
          .then((respuesta) => respuesta.json())
          .then((respuesta) => {
            if (respuesta.status) {
              this.mostrarError(respuesta.description || respuesta.message);
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'producto-nerea', productVariantId: datos.get('id'), cartData: respuesta });
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: respuesta }));

            if (carritoNerea && typeof carritoNerea.refrescar === 'function') {
              carritoNerea.refrescar(true);
            } else if (usaCajon) {
              cajon.classList.remove('is-empty');
              cajon.renderContents(respuesta);
            } else {
              window.location.href = this.dataset.urlCarrito;
            }
          })
          .catch(() => {
            this.mostrarError('No se ha podido añadir al carrito. Inténtalo de nuevo.');
          })
          .finally(() => {
            boton.classList.remove('producto-nr__agregar--cargando');
            boton.removeAttribute('aria-busy');
          });
      }

      mostrarError(mensaje) {
        const error = this.querySelector('[data-error]');
        if (!error) return;
        error.textContent = mensaje;
        error.classList.remove('producto-nr__oculto');
      }

      ocultarError() {
        const error = this.querySelector('[data-error]');
        if (error) error.classList.add('producto-nr__oculto');
      }

      iniciarGuia() {
        const guia = this.querySelector('[data-guia]');
        const botones = this.querySelectorAll('[data-abrir-guia]');
        if (!guia || !botones.length || typeof guia.showModal !== 'function') return;

        const tabla = guia.querySelector('[data-tabla-scroll]');
        const deslizar = guia.querySelector('[data-deslizar]');

        const comprobarDesplazamiento = () => {
          if (!tabla || !deslizar) return;
          const desborda = tabla.scrollWidth > tabla.clientWidth + 2;
          const alFinal = tabla.scrollLeft + tabla.clientWidth >= tabla.scrollWidth - 2;
          deslizar.classList.toggle('producto-nr__oculto', !desborda || alFinal);
        };

        botones.forEach((boton) => {
          boton.addEventListener('click', () => {
            guia.showModal();
            document.body.style.overflow = 'hidden';
            requestAnimationFrame(comprobarDesplazamiento);
          });
        });

        if (tabla) tabla.addEventListener('scroll', comprobarDesplazamiento, { passive: true });
        window.addEventListener('resize', () => {
          if (guia.open) comprobarDesplazamiento();
        });

        guia.querySelectorAll('[data-cerrar-guia]').forEach((boton) => {
          boton.addEventListener('click', () => guia.close());
        });
        guia.addEventListener('click', (evento) => {
          if (evento.target === guia) guia.close();
        });
        guia.addEventListener('close', () => {
          document.body.style.overflow = '';
        });
      }

      iniciarPaquetes() {
        this.paquetes = this.querySelector('[data-paquetes]');
        if (!this.paquetes) return;
        const campoId = this.querySelector('[data-id-variante]');
        const idInicial = campoId ? parseInt(campoId.value, 10) : null;
        this.varianteActual = this.variantes.find((v) => v.id === idInicial) || this.variantes[0];

        this.paquetes.querySelectorAll('.producto-nr__paquete-radio').forEach((radio) => {
          radio.addEventListener('change', () => this.fijarCantidad(parseInt(radio.value, 10) || 1));
        });

        const marcado = this.paquetes.querySelector('.producto-nr__paquete-radio:checked');
        if (marcado) this.fijarCantidad(parseInt(marcado.value, 10) || 1);
      }

      fijarCantidad(cantidad) {
        const visible = this.querySelector('[data-cantidad-campo]');
        const oculta = this.querySelector('[data-cantidad-oculta]');
        if (visible) visible.value = cantidad;
        if (oculta) oculta.value = cantidad;
      }

      recalcularPaquetes(variante) {
        if (!this.paquetes || !variante || typeof variante.centimos !== 'number') return;
        this.paquetes.querySelectorAll('[data-paquete]').forEach((paquete) => {
          const unidades = parseInt(paquete.dataset.unidades, 10) || 1;
          const descuento = parseInt(paquete.dataset.descuento, 10) || 0;
          const antes = variante.centimos * unidades;
          const total = Math.floor((antes * (100 - descuento)) / 100);
          const ahorro = antes - total;
          const porUnidad = Math.floor(total / unidades);

          const campoTotal = paquete.querySelector('[data-paquete-total]');
          const campoAntes = paquete.querySelector('[data-paquete-antes]');
          const campoAhorro = paquete.querySelector('[data-paquete-ahorro]');
          const campoUnidad = paquete.querySelector('[data-paquete-unidad]');
          if (campoTotal) campoTotal.innerHTML = this.formatearDinero(total);
          if (campoAntes) campoAntes.innerHTML = this.formatearDinero(antes);
          if (campoAhorro) campoAhorro.innerHTML = this.formatearDinero(ahorro);
          if (campoUnidad) campoUnidad.innerHTML = this.formatearDinero(porUnidad);
        });
      }

      formatearDinero(centimos) {
        const formato = (this.paquetes && this.paquetes.dataset.formato) || '{{amount_with_comma_separator}} €';
        const separar = (decimales, miles, decimal) => {
          const fijo = (centimos / 100).toFixed(decimales);
          const partes = fijo.split('.');
          const entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return partes[1] ? entero + decimal + partes[1] : entero;
        };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (coincidencia, clave) => {
          switch (clave) {
            case 'amount_no_decimals':
              return separar(0, ',', '.');
            case 'amount_with_comma_separator':
              return separar(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return separar(0, '.', ',');
            case 'amount_with_space_separator':
              return separar(2, ' ', ',');
            case 'amount_with_period_and_space_separator':
              return separar(2, ' ', '.');
            case 'amount_no_decimals_with_space_separator':
              return separar(0, ' ', '');
            case 'amount_with_apostrophe_separator':
              return separar(2, "'", '.');
            default:
              return separar(2, ',', '.');
          }
        });
      }

      iniciarCantidad() {
        const campo = this.querySelector('[data-cantidad-campo]');
        if (!campo) return;
        this.querySelectorAll('[data-cantidad]').forEach((boton) => {
          boton.addEventListener('click', () => {
            const valor = (parseInt(campo.value, 10) || 1) + parseInt(boton.dataset.cantidad, 10);
            campo.value = Math.max(1, valor);
          });
        });
      }
    }

    customElements.define('producto-nerea', ProductoNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecera-neerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cabecera-nerea')) return;

    class CabeceraNerea extends HTMLElement {
      connectedCallback() {
        this.seccion = this.closest('.shopify-section');
        this.medioHover = window.matchMedia('(hover: hover) and (min-width: 990px)');

        this.alTeclado = this.alTeclado.bind(this);
        this.alClicFuera = this.alClicFuera.bind(this);
        this.alRedimensionar = this.alRedimensionar.bind(this);
        this.alDesplazar = this.alDesplazar.bind(this);
        this.alSeleccionarBloque = this.alSeleccionarBloque.bind(this);
        this.alDeseleccionarBloque = this.alDeseleccionarBloque.bind(this);
        this.actualizarContador = this.actualizarContador.bind(this);

        this.iniciarAnuncios();
        this.iniciarDesplegables();
        this.iniciarCajon();
        this.iniciarBuscador();
        this.iniciarCarrito();
        this.iniciarFijo();

        document.addEventListener('keydown', this.alTeclado);
        document.addEventListener('click', this.alClicFuera);
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
        window.addEventListener('resize', this.alRedimensionar);
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
        document.removeEventListener('keydown', this.alTeclado);
        document.removeEventListener('click', this.alClicFuera);
        document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.removeEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
        window.removeEventListener('resize', this.alRedimensionar);
        window.removeEventListener('scroll', this.alDesplazar);
        ['cart:updated', 'cart:refresh', 'cart:change'].forEach((evento) => {
          document.removeEventListener(evento, this.actualizarContador);
        });
        if (typeof this.desuscribir === 'function') this.desuscribir();
        if (this.scrollBloqueado) this.bloquearScroll(false);
        if (this.seccion && this.modoFijo && this.modoFijo !== 'ninguno') {
          ['position', 'top', 'zIndex', 'transform', 'transition'].forEach((propiedad) => {
            this.seccion.style[propiedad] = '';
          });
        }
      }

      iniciarAnuncios() {
        this.anuncios = Array.from(this.querySelectorAll('[data-anuncio]'));
        this.indiceAnuncio = 0;
        this.pausado = false;
        if (this.anuncios.length < 2) return;

        const anterior = this.querySelector('[data-anterior]');
        const siguiente = this.querySelector('[data-siguiente]');
        const zona = this.querySelector('[data-anuncios]');

        if (anterior) {
          anterior.addEventListener('click', () => {
            this.mostrarAnuncio(this.indiceAnuncio - 1);
            this.reiniciarAutoplay();
          });
        }

        if (siguiente) {
          siguiente.addEventListener('click', () => {
            this.mostrarAnuncio(this.indiceAnuncio + 1);
            this.reiniciarAutoplay();
          });
        }

        if (zona) {
          zona.addEventListener('mouseenter', () => {
            this.pausado = true;
          });
          zona.addEventListener('mouseleave', () => {
            this.pausado = false;
          });
        }

        this.reiniciarAutoplay();
      }

      mostrarAnuncio(indice) {
        const total = this.anuncios.length;
        if (!total) return;
        this.indiceAnuncio = (indice + total) % total;
        this.anuncios.forEach((anuncio, posicion) => {
          const activo = posicion === this.indiceAnuncio;
          anuncio.classList.toggle('cabecera-nr__anuncio--activo', activo);
          anuncio.toggleAttribute('inert', !activo);
        });
      }

      reiniciarAutoplay() {
        clearInterval(this.intervalo);
        if (this.dataset.autoplay !== 'true' || this.anuncios.length < 2) return;
        const segundos = parseInt(this.dataset.velocidad, 10) || 5;
        this.intervalo = setInterval(() => {
          if (!this.pausado) this.mostrarAnuncio(this.indiceAnuncio + 1);
        }, segundos * 1000);
      }

      alSeleccionarBloque(evento) {
        if (!this.anuncios || !evento.detail) return;
        const posicion = this.anuncios.findIndex((anuncio) => anuncio.dataset.bloque === evento.detail.blockId);
        if (posicion === -1) return;
        this.pausado = true;
        this.mostrarAnuncio(posicion);
      }

      alDeseleccionarBloque() {
        this.pausado = false;
      }

      iniciarDesplegables() {
        this.desplegables = Array.from(this.querySelectorAll('[data-desplegable]'));
        const alPasar = this.dataset.alPasar === 'true';

        this.desplegables.forEach((item) => {
          const boton = item.querySelector('[data-desplegable-boton]');
          if (!boton) return;

          boton.addEventListener('click', (evento) => {
            evento.preventDefault();
            if (alPasar && this.medioHover.matches) {
              this.abrirDesplegable(item);
              return;
            }
            if (item.classList.contains('cabecera-nr__menu-item--abierto')) {
              this.cerrarDesplegable(item);
            } else {
              this.abrirDesplegable(item);
            }
          });

          item.addEventListener('focusout', (evento) => {
            if (!item.contains(evento.relatedTarget)) this.cerrarDesplegable(item);
          });

          if (alPasar) {
            item.addEventListener('mouseenter', () => {
              if (this.medioHover.matches) this.abrirDesplegable(item);
            });
            item.addEventListener('mouseleave', () => {
              if (this.medioHover.matches) this.cerrarDesplegable(item);
            });
          }
        });
      }

      abrirDesplegable(item) {
        this.desplegables.forEach((otro) => {
          if (otro !== item) this.cerrarDesplegable(otro);
        });
        item.classList.add('cabecera-nr__menu-item--abierto');
        const boton = item.querySelector('[data-desplegable-boton]');
        if (boton) boton.setAttribute('aria-expanded', 'true');
      }

      cerrarDesplegable(item) {
        item.classList.remove('cabecera-nr__menu-item--abierto');
        const boton = item.querySelector('[data-desplegable-boton]');
        if (boton) boton.setAttribute('aria-expanded', 'false');
      }

      cerrarDesplegables(devolverFoco) {
        if (!this.desplegables) return;
        this.desplegables.forEach((item) => {
          const estabaAbierto = item.classList.contains('cabecera-nr__menu-item--abierto');
          this.cerrarDesplegable(item);
          if (estabaAbierto && devolverFoco) {
            const boton = item.querySelector('[data-desplegable-boton]');
            if (boton) boton.focus();
          }
        });
      }

      alClicFuera(evento) {
        if (!evento.target.closest('[data-desplegable]')) this.cerrarDesplegables(false);
      }

      iniciarCajon() {
        this.cajon = this.querySelector('[data-cajon]');
        this.botonMenu = this.querySelector('[data-abrir-menu]');
        if (!this.cajon || !this.botonMenu) return;

        this.botonMenu.addEventListener('click', () => this.abrirCajon());
        this.cajon.querySelectorAll('[data-cerrar-menu]').forEach((elemento) => {
          elemento.addEventListener('click', () => this.cerrarCajon(true));
        });
      }

      cajonAbierto() {
        return !!this.cajon && this.cajon.classList.contains('cabecera-nr__cajon--abierto');
      }

      abrirCajon() {
        this.cajon.classList.add('cabecera-nr__cajon--abierto');
        this.botonMenu.setAttribute('aria-expanded', 'true');
        this.bloquearScroll(true);
        const cerrar = this.cajon.querySelector('[data-cerrar-menu-boton]');
        setTimeout(() => {
          if (cerrar) cerrar.focus();
        }, 60);
      }

      cerrarCajon(devolverFoco) {
        if (!this.cajonAbierto()) return;
        this.cajon.classList.remove('cabecera-nr__cajon--abierto');
        this.botonMenu.setAttribute('aria-expanded', 'false');
        this.bloquearScroll(false);
        if (devolverFoco) this.botonMenu.focus();
      }

      iniciarBuscador() {
        this.buscador = this.querySelector('[data-buscador]');
        if (!this.buscador) return;
        this.campoBusqueda = this.buscador.querySelector('[data-campo-busqueda]');

        this.querySelectorAll('[data-abrir-buscador]').forEach((boton) => {
          boton.addEventListener('click', () => this.abrirBuscador(boton));
        });
        this.buscador.querySelectorAll('[data-cerrar-buscador]').forEach((elemento) => {
          elemento.addEventListener('click', () => this.cerrarBuscador(true));
        });
      }

      buscadorAbierto() {
        return !!this.buscador && this.buscador.classList.contains('cabecera-nr__buscador--abierto');
      }

      abrirBuscador(boton) {
        this.botonBuscadorActivo = boton;
        this.cerrarDesplegables(false);
        this.buscador.classList.add('cabecera-nr__buscador--abierto');
        this.bloquearScroll(true);
        setTimeout(() => {
          if (this.campoBusqueda) this.campoBusqueda.focus();
        }, 80);
      }

      cerrarBuscador(devolverFoco) {
        if (!this.buscadorAbierto()) return;
        this.buscador.classList.remove('cabecera-nr__buscador--abierto');
        this.bloquearScroll(false);
        if (devolverFoco && this.botonBuscadorActivo) this.botonBuscadorActivo.focus();
      }

      bloquearScroll(estado) {
        this.scrollBloqueado = estado;
        document.body.style.overflow = estado ? 'hidden' : '';
      }

      iniciarCarrito() {
        this.enlaceCarrito = this.querySelector('[data-carrito]');
        this.contador = this.querySelector('[data-contador]');
        if (!this.enlaceCarrito) return;

        this.enlaceCarrito.addEventListener('click', (evento) => {
          const cajonCarrito = document.querySelector('cart-drawer');
          if (cajonCarrito && typeof cajonCarrito.open === 'function') {
            evento.preventDefault();
            cajonCarrito.open(this.enlaceCarrito);
          }
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.desuscribir = subscribe(PUB_SUB_EVENTS.cartUpdate, this.actualizarContador);
        }

        ['cart:updated', 'cart:refresh', 'cart:change'].forEach((evento) => {
          document.addEventListener(evento, this.actualizarContador);
        });
      }

      actualizarContador() {
        if (!this.contador) return;
        fetch(this.dataset.urlCarrito + '.js', { headers: { Accept: 'application/json' } })
          .then((respuesta) => respuesta.json())
          .then((carrito) => {
            this.contador.textContent = carrito.item_count;
            this.contador.classList.toggle('cabecera-nr__contador--vacio', carrito.item_count === 0);
          })
          .catch(() => {});
      }

      iniciarFijo() {
        this.modoFijo = this.dataset.fijo;
        if (!this.seccion || this.modoFijo === 'ninguno') return;

        this.seccion.style.position = 'sticky';
        this.seccion.style.zIndex = '40';
        this.ajustarFijo();

        if (this.modoFijo === 'al-subir') {
          this.seccion.style.transition = 'transform 0.3s ease';
          this.ultimoScroll = window.scrollY;
          window.addEventListener('scroll', this.alDesplazar, { passive: true });
        }
      }

      ajustarFijo() {
        const anuncios = this.querySelector('[data-anuncios]');
        const alto = anuncios ? anuncios.offsetHeight : 0;
        this.seccion.style.top = -alto + 'px';
      }

      alDesplazar() {
        const actual = window.scrollY;
        if (this.cajonAbierto() || this.buscadorAbierto()) {
          this.ultimoScroll = actual;
          return;
        }
        const limite = this.seccion.offsetHeight;
        if (actual > this.ultimoScroll && actual > limite) {
          this.seccion.style.transform = 'translateY(-100%)';
          this.cerrarDesplegables(false);
        } else if (actual < this.ultimoScroll) {
          this.seccion.style.transform = '';
        }
        this.ultimoScroll = actual;
      }

      alRedimensionar() {
        if (this.seccion && this.modoFijo && this.modoFijo !== 'ninguno') this.ajustarFijo();
        if (window.innerWidth >= 990) this.cerrarCajon(false);
      }

      alTeclado(evento) {
        if (evento.key !== 'Escape') return;
        if (this.buscadorAbierto()) {
          this.cerrarBuscador(true);
        } else if (this.cajonAbierto()) {
          this.cerrarCajon(true);
        } else {
          this.cerrarDesplegables(true);
        }
      }
    }

    customElements.define('cabecera-nerea', CabeceraNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrito-nerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cart-drawer')) return;

    const CLAVE_FIN = 'carrito-nr-fin';

    class CarritoNerea extends HTMLElement {
      connectedCallback() {
        this.idSeccion = this.dataset.seccion;
        this.panel = this.querySelector('.carrito-nr__panel');

        this.alClicDocumento = this.alClicDocumento.bind(this);
        this.alTeclado = this.alTeclado.bind(this);
        this.alSeleccionarSeccion = this.alSeleccionarSeccion.bind(this);
        this.alDeseleccionarSeccion = this.alDeseleccionarSeccion.bind(this);

        document.addEventListener('click', this.alClicDocumento, true);
        document.addEventListener('keydown', this.alTeclado);
        document.addEventListener('shopify:section:select', this.alSeleccionarSeccion);
        document.addEventListener('shopify:section:deselect', this.alDeseleccionarSeccion);

        this.addEventListener('click', (evento) => this.alClicInterno(evento));
        this.addEventListener('change', (evento) => {
          const campo = evento.target.closest('[data-cantidad-linea]');
          if (!campo) return;
          const linea = campo.closest('[data-linea]');
          const cantidad = Math.max(0, parseInt(campo.value, 10) || 0);
          if (linea) this.cambiarLinea(linea.dataset.clave, cantidad);
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.desuscribir = subscribe(PUB_SUB_EVENTS.cartUpdate, (evento) => {
            if (!evento || evento.source === 'carrito-nerea' || evento.source === 'producto-nerea' || evento.source === 'product-form') return;
            this.refrescar(false);
          });
        }

        this.iniciarTemporizador();
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
        document.removeEventListener('click', this.alClicDocumento, true);
        document.removeEventListener('keydown', this.alTeclado);
        document.removeEventListener('shopify:section:select', this.alSeleccionarSeccion);
        document.removeEventListener('shopify:section:deselect', this.alDeseleccionarSeccion);
        if (typeof this.desuscribir === 'function') this.desuscribir();
        document.body.style.overflow = '';
      }

      estaAbierto() {
        return this.classList.contains('carrito-nr--abierto');
      }

      abrir(origen) {
        this.origen = origen || document.activeElement;
        this.classList.add('carrito-nr--abierto');
        document.body.style.overflow = 'hidden';
        const cerrar = this.querySelector('[data-boton-cerrar]');
        setTimeout(() => {
          if (cerrar) cerrar.focus();
        }, 80);
      }

      open(origen) {
        this.abrir(origen);
      }

      cerrar() {
        if (!this.estaAbierto()) return;
        this.classList.remove('carrito-nr--abierto');
        document.body.style.overflow = '';
        if (this.origen && typeof this.origen.focus === 'function') this.origen.focus();
      }

      close() {
        this.cerrar();
      }

      getSectionsToRender() {
        return [{ id: this.idSeccion, section: this.idSeccion, selector: '[data-contenido-carrito]' }];
      }

      setActiveElement(elemento) {
        this.origen = elemento;
      }

      renderContents(respuesta) {
        if (respuesta && respuesta.sections && respuesta.sections[this.idSeccion]) {
          this.pintar(respuesta.sections[this.idSeccion]);
          this.abrir();
        } else {
          this.refrescar(true);
        }
      }

      alClicDocumento(evento) {
        if (this.dataset.interceptar !== 'true') return;
        const urlCarrito = this.dataset.urlCarrito;
        const selector = '[data-carrito], #cart-icon-bubble, a[href="' + urlCarrito + '"]';
        const enlace = evento.target.closest(selector);
        if (!enlace || this.contains(enlace)) return;
        if (evento.metaKey || evento.ctrlKey || evento.shiftKey) return;
        evento.preventDefault();
        evento.stopPropagation();
        this.abrir(enlace);
      }

      alClicInterno(evento) {
        if (evento.target.closest('[data-cerrar-carrito]')) {
          this.cerrar();
          return;
        }

        const linea = evento.target.closest('[data-linea]');
        if (!linea) return;
        const campo = linea.querySelector('[data-cantidad-linea]');
        const actual = campo ? parseInt(campo.value, 10) || 0 : 0;

        if (evento.target.closest('[data-eliminar]')) {
          this.cambiarLinea(linea.dataset.clave, 0);
        } else if (evento.target.closest('[data-cantidad-mas]')) {
          if (campo) campo.value = actual + 1;
          this.cambiarLinea(linea.dataset.clave, actual + 1);
        } else if (evento.target.closest('[data-cantidad-menos]')) {
          const nueva = Math.max(0, actual - 1);
          if (campo) campo.value = nueva;
          this.cambiarLinea(linea.dataset.clave, nueva);
        }
      }

      alTeclado(evento) {
        if (evento.key === 'Escape' && this.estaAbierto()) this.cerrar();
      }

      alSeleccionarSeccion(evento) {
        if (evento.detail && evento.detail.sectionId === this.idSeccion) this.abrir();
      }

      alDeseleccionarSeccion(evento) {
        if (evento.detail && evento.detail.sectionId === this.idSeccion) this.cerrar();
      }

      cargando(estado) {
        this.classList.toggle('carrito-nr--cargando', estado);
      }

      cambiarLinea(clave, cantidad) {
        this.ocultarError();
        this.cargando(true);

        fetch(this.dataset.urlCambiar + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: clave,
            quantity: cantidad,
            sections: [this.idSeccion],
            sections_url: window.location.pathname
          })
        })
          .then((respuesta) => respuesta.json().then((datos) => ({ ok: respuesta.ok, datos })))
          .then(({ ok, datos }) => {
            if (!ok || datos.status) {
              this.mostrarError(datos.description || datos.message);
              return this.refrescar(false);
            }
            if (datos.sections && datos.sections[this.idSeccion]) {
              this.pintar(datos.sections[this.idSeccion]);
            } else {
              this.refrescar(false);
            }
            this.notificar(datos);
          })
          .catch(() => this.mostrarError())
          .finally(() => this.cargando(false));
      }

      refrescar(abrir) {
        const url = this.dataset.urlRaiz.replace(/\/$/, '') + '/?section_id=' + encodeURIComponent(this.idSeccion);
        return fetch(url)
          .then((respuesta) => respuesta.text())
          .then((html) => {
            this.pintar(html);
            if (abrir) this.abrir();
          })
          .catch(() => {
            if (abrir) window.location.href = this.dataset.urlCarrito;
          });
      }

      pintar(html) {
        if (!html) return;
        const documento = new DOMParser().parseFromString(html, 'text/html');
        const nuevo = documento.querySelector('[data-contenido-carrito]');
        const actual = this.querySelector('[data-contenido-carrito]');
        if (!nuevo || !actual) return;
        actual.innerHTML = nuevo.innerHTML;
        actual.dataset.cantidad = nuevo.dataset.cantidad || '0';
        this.tic();
      }

      notificar(datos) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: datos }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'carrito-nerea', cartData: datos });
        }
      }

      mostrarError(mensaje) {
        const error = this.querySelector('[data-error-carrito]');
        if (!error) return;
        error.textContent = mensaje || this.dataset.textoError;
        error.classList.remove('carrito-nr__oculto');
      }

      ocultarError() {
        const error = this.querySelector('[data-error-carrito]');
        if (error) error.classList.add('carrito-nr__oculto');
      }

      iniciarTemporizador() {
        if (this.dataset.temporizador !== 'true') return;
        this.duracion = (parseInt(this.dataset.minutos, 10) || 10) * 60000;
        let fin = 0;
        try {
          fin = parseInt(window.sessionStorage.getItem(CLAVE_FIN), 10) || 0;
        } catch (error) {
          fin = 0;
        }
        if (!fin || fin <= Date.now() || fin - Date.now() > this.duracion) fin = Date.now() + this.duracion;
        this.fin = fin;
        this.guardarFin();
        this.tic();
        this.intervalo = setInterval(() => this.tic(), 1000);
      }

      guardarFin() {
        try {
          window.sessionStorage.setItem(CLAVE_FIN, String(this.fin));
        } catch (error) {
          return;
        }
      }

      tic() {
        if (!this.fin) return;
        let resta = this.fin - Date.now();
        if (resta <= 0) {
          this.fin = Date.now() + this.duracion;
          this.guardarFin();
          resta = this.duracion;
        }
        const minutos = Math.floor(resta / 60000);
        const segundos = Math.floor((resta % 60000) / 1000);
        const texto = String(minutos).padStart(2, '0') + ':' + String(segundos).padStart(2, '0');
        this.querySelectorAll('[data-tiempo]').forEach((elemento) => {
          elemento.textContent = texto;
        });
      }
    }

    customElements.define('cart-drawer', CarritoNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opiniones-nerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('opiniones-nerea')) return;

    class OpinionesNerea extends HTMLElement {
      connectedCallback() {
        this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta]'));
        if (!this.tarjetas.length) return;

        const inicio = (parseInt(this.dataset.inicio, 10) || 1) - 1;
        this.indice = Math.min(Math.max(inicio, 0), this.tarjetas.length - 1);
        this.pausado = false;

        this.alSeleccionarBloque = this.alSeleccionarBloque.bind(this);
        this.alDeseleccionarBloque = this.alDeseleccionarBloque.bind(this);
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionarBloque);

        const anterior = this.querySelector('[data-anterior]');
        const siguiente = this.querySelector('[data-siguiente]');
        if (anterior) anterior.addEventListener('click', () => this.ir(this.indice - 1));
        if (siguiente) siguiente.addEventListener('click', () => this.ir(this.indice + 1));

        this.tarjetas.forEach((tarjeta, posicion) => {
          tarjeta.addEventListener('click', () => {
            if (posicion !== this.indice) this.ir(posicion);
          });
        });

        const escenario = this.querySelector('[data-escenario]');
        if (escenario) {
          escenario.addEventListener('touchstart', (evento) => {
            this.inicioToque = evento.touches[0].clientX;
          }, { passive: true });
          escenario.addEventListener('touchend', (evento) => {
            if (this.inicioToque === undefined) return;
            const diferencia = evento.changedTouches[0].clientX - this.inicioToque;
            this.inicioToque = undefined;
            if (Math.abs(diferencia) < 40) return;
            this.ir(this.indice + (diferencia < 0 ? 1 : -1));
          }, { passive: true });
        }

        this.addEventListener('mouseenter', () => {
          this.pausado = true;
        });
        this.addEventListener('mouseleave', () => {
          this.pausado = false;
        });

        this.pintar();
        this.reiniciar();
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
        document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.removeEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
      }

      ir(indice) {
        const total = this.tarjetas.length;
        this.indice = (indice + total) % total;
        this.pintar();
        this.reiniciar();
      }

      pintar() {
        const total = this.tarjetas.length;
        this.tarjetas.forEach((tarjeta, posicion) => {
          const distancia = (posicion - this.indice + total) % total;
          let estado = 'oculta';
          if (distancia === 0) {
            estado = 'activa';
          } else if (distancia === 1) {
            estado = 'siguiente';
          } else if (distancia === total - 1) {
            estado = 'anterior';
          }
          tarjeta.classList.toggle('opiniones-nr__tarjeta--activa', estado === 'activa');
          tarjeta.classList.toggle('opiniones-nr__tarjeta--siguiente', estado === 'siguiente');
          tarjeta.classList.toggle('opiniones-nr__tarjeta--anterior', estado === 'anterior');
          tarjeta.setAttribute('aria-hidden', estado === 'activa' ? 'false' : 'true');
        });
      }

      reiniciar() {
        clearInterval(this.intervalo);
        if (this.dataset.autoplay !== 'true' || this.tarjetas.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const segundos = parseInt(this.dataset.velocidad, 10) || 6;
        this.intervalo = setInterval(() => {
          if (this.pausado) return;
          const total = this.tarjetas.length;
          this.indice = (this.indice + 1) % total;
          this.pintar();
        }, segundos * 1000);
      }

      alSeleccionarBloque(evento) {
        if (!evento.detail) return;
        const posicion = this.tarjetas.findIndex((t) => t.dataset.bloque === evento.detail.blockId);
        if (posicion === -1) return;
        this.pausado = true;
        this.indice = posicion;
        this.pintar();
      }

      alDeseleccionarBloque() {
        this.pausado = false;
      }
    }

    customElements.define('opiniones-nerea', OpinionesNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relacionedo-nerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('relacionados-nerea')) return;

    class RelacionadosNerea extends HTMLElement {
      connectedCallback() {
        this.alRedimensionar = this.alRedimensionar.bind(this);

        if (this.dataset.url) {
          this.cargar();
        } else {
          this.iniciar();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.alRedimensionar);
      }

      cargar() {
        fetch(this.dataset.url)
          .then((respuesta) => respuesta.text())
          .then((html) => {
            const documento = new DOMParser().parseFromString(html, 'text/html');
            const origen = documento.querySelector('#' + this.id + ' [data-contenido]');
            const destino = this.querySelector('[data-contenido]');
            if (!origen || !destino || !origen.querySelector('[data-tarjeta]')) {
              this.ocultar();
              return;
            }
            destino.innerHTML = origen.innerHTML;
            this.iniciar();
          })
          .catch(() => this.ocultar());
      }

      ocultar() {
        const seccion = this.closest('.shopify-section');
        if (seccion) {
          seccion.style.display = 'none';
        } else {
          this.style.display = 'none';
        }
      }

      iniciar() {
        this.pista = this.querySelector('[data-pista]');
        this.tarjetas = Array.from(this.querySelectorAll('[data-tarjeta]'));
        this.anterior = this.querySelector('[data-anterior]');
        this.siguiente = this.querySelector('[data-siguiente]');
        this.contador = this.querySelector('[data-contador]');
        this.navegacion = this.querySelector('[data-navegacion]');
        if (!this.pista || !this.tarjetas.length) return;

        if (this.anterior) this.anterior.addEventListener('click', () => this.mover(-1));
        if (this.siguiente) this.siguiente.addEventListener('click', () => this.mover(1));

        let espera;
        this.pista.addEventListener('scroll', () => {
          clearTimeout(espera);
          espera = setTimeout(() => this.actualizar(), 60);
        }, { passive: true });

        window.addEventListener('resize', this.alRedimensionar);
        this.actualizar();
      }

      alRedimensionar() {
        clearTimeout(this.esperaResize);
        this.esperaResize = setTimeout(() => this.actualizar(), 120);
      }

      paso() {
        const primera = this.tarjetas[0];
        const segunda = this.tarjetas[1];
        if (!primera) return 1;
        if (segunda) return segunda.offsetLeft - primera.offsetLeft;
        return primera.getBoundingClientRect().width;
      }

      visibles() {
        const ancho = this.tarjetas[0].getBoundingClientRect().width || 1;
        const hueco = this.paso() - ancho;
        return Math.max(1, Math.floor((this.pista.clientWidth + hueco + 2) / (ancho + hueco)));
      }

      mover(direccion) {
        this.pista.scrollBy({ left: direccion * this.paso(), behavior: 'smooth' });
      }

      actualizar() {
        const total = Math.max(1, this.tarjetas.length - this.visibles() + 1);
        const paso = this.paso() || 1;
        let indice = Math.round(this.pista.scrollLeft / paso);
        const alFinal = this.pista.scrollLeft + this.pista.clientWidth >= this.pista.scrollWidth - 4;
        if (alFinal) indice = total - 1;
        indice = Math.min(Math.max(indice, 0), total - 1);

        if (this.contador) this.contador.textContent = (indice + 1) + '/' + total;
        if (this.anterior) this.anterior.disabled = indice === 0;
        if (this.siguiente) this.siguiente.disabled = indice >= total - 1;
        if (this.navegacion) this.navegacion.classList.toggle('relacionados-nr__navegacion--oculta', total <= 1);
      }
    }

    customElements.define('relacionados-nerea', RelacionadosNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tallas-nerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('producto-nerea')) return;

    class ProductoNerea extends HTMLElement {
      connectedCallback() {
        const datos = this.querySelector('[data-variantes-json]');
        this.variantes = datos ? JSON.parse(datos.textContent) : [];
        this.pista = this.querySelector('[data-pista]');
        this.diapositivas = Array.from(this.querySelectorAll('[data-diapositiva]'));
        this.miniaturas = Array.from(this.querySelectorAll('[data-miniatura]'));
        this.puntos = Array.from(this.querySelectorAll('[data-punto]'));
        this.formulario = this.querySelector('.producto-nr__formulario');
        this.indiceActivo = 0;

        this.iniciarGaleria();
        this.iniciarVariantes();
        this.iniciarFormulario();
        this.iniciarGuia();
        this.iniciarCantidad();
        this.iniciarPaquetes();

        const inicial = parseInt(this.dataset.mediaInicial, 10) || 0;
        requestAnimationFrame(() => this.irA(inicial, false));
      }

      iniciarGaleria() {
        if (!this.pista) return;

        this.miniaturas.forEach((miniatura) => {
          miniatura.addEventListener('click', () => this.irA(parseInt(miniatura.dataset.indice, 10), true));
        });

        this.puntos.forEach((punto) => {
          punto.addEventListener('click', () => this.irA(parseInt(punto.dataset.indice, 10), true));
        });

        let espera;
        this.pista.addEventListener('scroll', () => {
          clearTimeout(espera);
          espera = setTimeout(() => {
            const ancho = this.pista.clientWidth || 1;
            const indice = Math.round(this.pista.scrollLeft / ancho);
            this.marcarActivo(indice);
          }, 60);
        }, { passive: true });
      }

      irA(indice, suave) {
        const destino = this.diapositivas[indice];
        if (!destino || !this.pista) return;
        this.pista.scrollTo({ left: destino.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
        this.marcarActivo(indice);
      }

      marcarActivo(indice) {
        this.indiceActivo = indice;
        this.miniaturas.forEach((miniatura, posicion) => {
          miniatura.classList.toggle('producto-nr__miniatura--activa', posicion === indice);
        });
        const activa = this.miniaturas[indice];
        const columna = activa ? activa.parentElement : null;
        if (activa && columna && columna.scrollHeight > columna.clientHeight) {
          columna.scrollTo({ top: activa.offsetTop - (columna.clientHeight - activa.clientHeight) / 2, behavior: 'smooth' });
        }
        this.puntos.forEach((punto, posicion) => {
          punto.classList.toggle('producto-nr__punto--activo', posicion === indice);
        });
      }

      iniciarVariantes() {
        this.radios = Array.from(this.querySelectorAll('.producto-nr__radio'));
        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.alCambiarOpcion(radio));
        });
        this.marcarDisponibilidad();
      }

      opcionesSeleccionadas() {
        const seleccion = [];
        this.querySelectorAll('[data-opcion]').forEach((grupo) => {
          const posicion = parseInt(grupo.dataset.posicion, 10) - 1;
          const marcado = grupo.querySelector('.producto-nr__radio:checked');
          seleccion[posicion] = marcado ? marcado.value : null;
        });
        return seleccion;
      }

      alCambiarOpcion(radio) {
        const seleccion = this.opcionesSeleccionadas();
        let variante = this.variantes.find((v) => v.opciones.every((valor, i) => seleccion[i] === undefined || seleccion[i] === null || seleccion[i] === valor));

        if (!variante || !variante.disponible) {
          const posicion = parseInt(radio.dataset.posicion, 10) - 1;
          const alternativa = this.variantes.find((v) => v.disponible && v.opciones[posicion] === radio.value);
          if (alternativa && !variante) {
            variante = alternativa;
            this.aplicarSeleccion(alternativa);
          }
        }

        if (variante) this.actualizar(variante);
        this.marcarDisponibilidad();
      }

      aplicarSeleccion(variante) {
        variante.opciones.forEach((valor, i) => {
          const grupo = this.querySelector('[data-opcion][data-posicion="' + (i + 1) + '"]');
          if (!grupo) return;
          grupo.querySelectorAll('.producto-nr__radio').forEach((radio) => {
            radio.checked = radio.value === valor;
          });
        });
      }

      marcarDisponibilidad() {
        const seleccion = this.opcionesSeleccionadas();
        this.querySelectorAll('[data-opcion]').forEach((grupo) => {
          const posicion = parseInt(grupo.dataset.posicion, 10) - 1;
          grupo.querySelectorAll('.producto-nr__valor').forEach((etiqueta) => {
            const radio = etiqueta.querySelector('.producto-nr__radio');
            const disponible = this.variantes.some((v) => {
              if (!v.disponible || v.opciones[posicion] !== radio.value) return false;
              return v.opciones.every((valor, i) => i === posicion || seleccion[i] === null || seleccion[i] === undefined || seleccion[i] === valor);
            });
            etiqueta.classList.toggle('producto-nr__valor--agotado', !disponible);
          });
          const marcado = grupo.querySelector('.producto-nr__radio:checked');
          const texto = grupo.querySelector('[data-valor-seleccionado]');
          if (texto && marcado) texto.textContent = marcado.value;
        });
      }

      actualizar(variante) {
        this.varianteActual = variante;

        const campoId = this.querySelector('[data-id-variante]');
        if (campoId) campoId.value = variante.id;

        const antes = this.querySelector('[data-precio-antes]');
        const actual = this.querySelector('[data-precio-actual]');
        const etiqueta = this.querySelector('[data-etiqueta]');
        const enOferta = Boolean(variante.antes);

        if (actual) {
          actual.innerHTML = variante.precio;
          actual.classList.toggle('producto-nr__precio-actual--oferta', enOferta);
        }
        if (antes) {
          antes.innerHTML = enOferta ? variante.antes : '';
          antes.classList.toggle('producto-nr__oculto', !enOferta);
        }
        if (etiqueta) {
          if (enOferta) {
            etiqueta.innerHTML = (etiqueta.dataset.plantilla || '')
              .replace('[porcentaje]', variante.porcentaje)
              .replace('[ahorro]', variante.ahorro);
          }
          etiqueta.classList.toggle('producto-nr__oculto', !enOferta);
        }

        const boton = this.querySelector('[data-agregar]');
        if (boton) {
          boton.disabled = !variante.disponible;
          const textoBoton = boton.querySelector('[data-agregar-texto]');
          if (textoBoton) textoBoton.textContent = variante.disponible ? boton.dataset.textoAgregar : boton.dataset.textoAgotado;
        }

        const stock = this.querySelector('[data-stock]');
        if (stock) {
          let visible = false;
          if (variante.disponible) {
            if (stock.dataset.modo === 'siempre') {
              visible = true;
            } else if (variante.inventario !== null && variante.inventario > 0 && variante.inventario <= parseInt(stock.dataset.umbral, 10)) {
              visible = true;
            }
          }
          stock.classList.toggle('producto-nr__oculto', !visible);
        }

        if (variante.media) {
          const indice = this.diapositivas.findIndex((d) => d.dataset.mediaId === String(variante.media));
          if (indice > -1) this.irA(indice, true);
        }

        if (this.dataset.actualizarUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variante.id);
          window.history.replaceState({}, '', url.toString());
        }

        this.recalcularPaquetes(variante);
        this.ocultarError();
      }

      iniciarFormulario() {
        if (!this.formulario) return;
        this.formulario.addEventListener('submit', (evento) => {
          evento.preventDefault();
          this.agregarAlCarrito();
        });
      }

      agregarAlCarrito() {
        const boton = this.querySelector('[data-agregar]');
        if (!boton || boton.disabled || boton.classList.contains('producto-nr__agregar--cargando')) return;

        this.ocultarError();
        boton.classList.add('producto-nr__agregar--cargando');
        boton.setAttribute('aria-busy', 'true');

        const datos = new FormData(this.formulario);
        const carritoNerea = document.querySelector('carrito-nerea');
        const cajon = document.querySelector('cart-drawer');
        const usaCajon = !carritoNerea && cajon && typeof cajon.renderContents === 'function' && typeof cajon.getSectionsToRender === 'function';

        if (usaCajon) {
          datos.append('sections', cajon.getSectionsToRender().map((s) => s.id));
          datos.append('sections_url', window.location.pathname);
        }

        fetch(this.dataset.urlAgregar + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: datos
        })
          .then((respuesta) => respuesta.json())
          .then((respuesta) => {
            if (respuesta.status) {
              this.mostrarError(respuesta.description || respuesta.message);
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'producto-nerea', productVariantId: datos.get('id'), cartData: respuesta });
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: respuesta }));

            if (carritoNerea && typeof carritoNerea.refrescar === 'function') {
              carritoNerea.refrescar(true);
            } else if (usaCajon) {
              cajon.classList.remove('is-empty');
              cajon.renderContents(respuesta);
            } else {
              window.location.href = this.dataset.urlCarrito;
            }
          })
          .catch(() => {
            this.mostrarError('No se ha podido añadir al carrito. Inténtalo de nuevo.');
          })
          .finally(() => {
            boton.classList.remove('producto-nr__agregar--cargando');
            boton.removeAttribute('aria-busy');
          });
      }

      mostrarError(mensaje) {
        const error = this.querySelector('[data-error]');
        if (!error) return;
        error.textContent = mensaje;
        error.classList.remove('producto-nr__oculto');
      }

      ocultarError() {
        const error = this.querySelector('[data-error]');
        if (error) error.classList.add('producto-nr__oculto');
      }

      iniciarGuia() {
        const guia = this.querySelector('[data-guia]');
        const botones = this.querySelectorAll('[data-abrir-guia]');
        if (!guia || !botones.length || typeof guia.showModal !== 'function') return;

        const tabla = guia.querySelector('[data-tabla-scroll]');
        const deslizar = guia.querySelector('[data-deslizar]');

        const comprobarDesplazamiento = () => {
          if (!tabla || !deslizar) return;
          const desborda = tabla.scrollWidth > tabla.clientWidth + 2;
          const alFinal = tabla.scrollLeft + tabla.clientWidth >= tabla.scrollWidth - 2;
          deslizar.classList.toggle('producto-nr__oculto', !desborda || alFinal);
        };

        botones.forEach((boton) => {
          boton.addEventListener('click', () => {
            guia.showModal();
            document.body.style.overflow = 'hidden';
            requestAnimationFrame(comprobarDesplazamiento);
          });
        });

        if (tabla) tabla.addEventListener('scroll', comprobarDesplazamiento, { passive: true });
        window.addEventListener('resize', () => {
          if (guia.open) comprobarDesplazamiento();
        });

        guia.querySelectorAll('[data-cerrar-guia]').forEach((boton) => {
          boton.addEventListener('click', () => guia.close());
        });
        guia.addEventListener('click', (evento) => {
          if (evento.target === guia) guia.close();
        });
        guia.addEventListener('close', () => {
          document.body.style.overflow = '';
        });
      }

      iniciarPaquetes() {
        this.paquetes = this.querySelector('[data-paquetes]');
        if (!this.paquetes) return;
        const campoId = this.querySelector('[data-id-variante]');
        const idInicial = campoId ? parseInt(campoId.value, 10) : null;
        this.varianteActual = this.variantes.find((v) => v.id === idInicial) || this.variantes[0];

        this.paquetes.querySelectorAll('.producto-nr__paquete-radio').forEach((radio) => {
          radio.addEventListener('change', () => this.fijarCantidad(parseInt(radio.value, 10) || 1));
        });

        const marcado = this.paquetes.querySelector('.producto-nr__paquete-radio:checked');
        if (marcado) this.fijarCantidad(parseInt(marcado.value, 10) || 1);
      }

      fijarCantidad(cantidad) {
        const visible = this.querySelector('[data-cantidad-campo]');
        const oculta = this.querySelector('[data-cantidad-oculta]');
        if (visible) visible.value = cantidad;
        if (oculta) oculta.value = cantidad;
      }

      recalcularPaquetes(variante) {
        if (!this.paquetes || !variante || typeof variante.centimos !== 'number') return;
        this.paquetes.querySelectorAll('[data-paquete]').forEach((paquete) => {
          const unidades = parseInt(paquete.dataset.unidades, 10) || 1;
          const descuento = parseInt(paquete.dataset.descuento, 10) || 0;
          const antes = variante.centimos * unidades;
          const total = Math.floor((antes * (100 - descuento)) / 100);
          const ahorro = antes - total;
          const porUnidad = Math.floor(total / unidades);

          const campoTotal = paquete.querySelector('[data-paquete-total]');
          const campoAntes = paquete.querySelector('[data-paquete-antes]');
          const campoAhorro = paquete.querySelector('[data-paquete-ahorro]');
          const campoUnidad = paquete.querySelector('[data-paquete-unidad]');
          if (campoTotal) campoTotal.innerHTML = this.formatearDinero(total);
          if (campoAntes) campoAntes.innerHTML = this.formatearDinero(antes);
          if (campoAhorro) campoAhorro.innerHTML = this.formatearDinero(ahorro);
          if (campoUnidad) campoUnidad.innerHTML = this.formatearDinero(porUnidad);
        });
      }

      formatearDinero(centimos) {
        const formato = (this.paquetes && this.paquetes.dataset.formato) || '{{amount_with_comma_separator}} €';
        const separar = (decimales, miles, decimal) => {
          const fijo = (centimos / 100).toFixed(decimales);
          const partes = fijo.split('.');
          const entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
          return partes[1] ? entero + decimal + partes[1] : entero;
        };
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (coincidencia, clave) => {
          switch (clave) {
            case 'amount_no_decimals':
              return separar(0, ',', '.');
            case 'amount_with_comma_separator':
              return separar(2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return separar(0, '.', ',');
            case 'amount_with_space_separator':
              return separar(2, ' ', ',');
            case 'amount_with_period_and_space_separator':
              return separar(2, ' ', '.');
            case 'amount_no_decimals_with_space_separator':
              return separar(0, ' ', '');
            case 'amount_with_apostrophe_separator':
              return separar(2, "'", '.');
            default:
              return separar(2, ',', '.');
          }
        });
      }

      iniciarCantidad() {
        const campo = this.querySelector('[data-cantidad-campo]');
        if (!campo) return;
        this.querySelectorAll('[data-cantidad]').forEach((boton) => {
          boton.addEventListener('click', () => {
            const valor = (parseInt(campo.value, 10) || 1) + parseInt(boton.dataset.cantidad, 10);
            campo.value = Math.max(1, valor);
          });
        });
      }
    }

    customElements.define('producto-nerea', ProductoNerea);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-nerea"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('testimonios-nerea')) return;

    class TestimoniosNerea extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-testimonio]'));
        this.indice = 0;
        this.pausado = false;

        this.alSeleccionarBloque = this.alSeleccionarBloque.bind(this);
        this.alDeseleccionarBloque = this.alDeseleccionarBloque.bind(this);
        document.addEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.addEventListener('shopify:block:deselect', this.alDeseleccionarBloque);

        if (this.items.length < 2) return;

        const anterior = this.querySelector('[data-anterior]');
        const siguiente = this.querySelector('[data-siguiente]');
        const ventana = this.querySelector('[data-ventana]');

        if (anterior) {
          anterior.addEventListener('click', () => {
            this.mostrar(this.indice - 1);
            this.reiniciar();
          });
        }

        if (siguiente) {
          siguiente.addEventListener('click', () => {
            this.mostrar(this.indice + 1);
            this.reiniciar();
          });
        }

        this.addEventListener('mouseenter', () => {
          this.pausado = true;
        });
        this.addEventListener('mouseleave', () => {
          this.pausado = false;
        });
        this.addEventListener('focusin', () => {
          this.pausado = true;
        });
        this.addEventListener('focusout', () => {
          this.pausado = false;
        });

        if (ventana) {
          ventana.addEventListener('touchstart', (evento) => {
            this.inicioToque = evento.touches[0].clientX;
          }, { passive: true });

          ventana.addEventListener('touchend', (evento) => {
            if (this.inicioToque === undefined) return;
            const diferencia = evento.changedTouches[0].clientX - this.inicioToque;
            this.inicioToque = undefined;
            if (Math.abs(diferencia) < 40) return;
            this.mostrar(this.indice + (diferencia < 0 ? 1 : -1));
            this.reiniciar();
          }, { passive: true });
        }

        this.reiniciar();
      }

      disconnectedCallback() {
        clearInterval(this.intervalo);
        document.removeEventListener('shopify:block:select', this.alSeleccionarBloque);
        document.removeEventListener('shopify:block:deselect', this.alDeseleccionarBloque);
      }

      mostrar(indice) {
        const total = this.items.length;
        if (!total) return;
        this.indice = (indice + total) % total;
        this.items.forEach((item, posicion) => {
          const activo = posicion === this.indice;
          item.classList.toggle('testimonios-nr__item--activo', activo);
          item.toggleAttribute('inert', !activo);
        });
      }

      reiniciar() {
        clearInterval(this.intervalo);
        if (this.dataset.autoplay !== 'true' || this.items.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const segundos = parseInt(this.dataset.velocidad, 10) || 6;
        this.intervalo = setInterval(() => {
          if (!this.pausado) this.mostrar(this.indice + 1);
        }, segundos * 1000);
      }

      alSeleccionarBloque(evento) {
        if (!evento.detail || !this.items) return;
        const posicion = this.items.findIndex((item) => item.dataset.bloque === evento.detail.blockId);
        if (posicion === -1) return;
        this.pausado = true;
        this.mostrar(posicion);
      }

      alDeseleccionarBloque() {
        this.pausado = false;
      }
    }

    customElements.define('testimonios-nerea', TestimoniosNerea);
  })();

  } catch(e) { console.error(e); }
})();
})();
